import { render, staticRenderFns } from "./ReviewsByRating.vue?vue&type=template&id=71c36be6&"
import script from "./ReviewsByRating.vue?vue&type=script&lang=js&"
export * from "./ReviewsByRating.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsByRating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports